var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['owc-tabs-builder', { 'owc-tabs-builder--dark': _vm.isDarkMode }]},[_vm._t("validation-box"),_c('div',{class:{
      'owc-tabs-builder__bar-container': _vm.isFullPageTabs,
    }},[_c('wb-horizontal-scroll',{staticClass:"wb-grid-container",attrs:{"theme":_vm.isDarkMode ? 'dark' : ''}},[_c('nav',{attrs:{"aria-label":_vm.navigationDescription}},[_c('ul',{class:[
            'owc-tabs-builder__bar',
            {
              'owc-tabs-builder__bar--with-border': !_vm.isFullPageTabs,
            },
          ]},[_vm._t("tab-bar")],2)])])],1),_vm._t("tab-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }